import EditCategoryModal, { EditCategoryModalProps } from './EditCategoryModal';

export type { EditCategoryModalProps };
export default EditCategoryModal;
